var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 433.25 433.25" }, props),
    React.createElement("path", { d: "M418.4 192.331c19.8-19.8 19.8-51.9 0-71.7l-.1-.1-78.6-78.3c-19.8-19.8-51.9-19.7-71.8 0l-169.5 169.6-54.2 54.1c-19.8 19.7-19.8 51.8-.1 71.6l48.3 48.3H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h297.4c5.5 0 10-4.5 10-10s-4.5-10-10-10H225l23.9-23.7 169.5-169.8zm-221.7 193.5h-76.1l-62.3-62.4c-12-12-11.9-31.4 0-43.4l47.1-47 122.2 122-30.9 30.8zm-77.1-166.9l162.5-162.5c12-12 31.5-12 43.5 0l78.6 78.4c12 12 12 31.4 0 43.5l-162.4 162.8-122.2-122.2z" })
  );
});